import 'pickadate/lib/picker';
import 'pickadate/lib/picker.date';
import 'pickadate/lib/legacy';

$(document).ready(function () {
	"use strict";

	function getHolidaysAndWeekends(year = new Date().getFullYear()) {
		const holidays = [
			{ month: 0, day: 1 },  // Capodanno (1 Gennaio)
			{ month: 0, day: 6 },  // Epifania (6 Gennaio)
			{ month: 3, day: 25 }, // Festa della Liberazione (25 Aprile)
			{ month: 4, day: 1 },  // Festa del Lavoro (1 Maggio)
			{ month: 5, day: 2 },  // Festa della Repubblica (2 Giugno)
			{ month: 7, day: 15 }, // Ferragosto (15 Agosto)
			{ month: 10, day: 1 }, // Tutti i Santi (1 Novembre)
			{ month: 11, day: 8 }, // Immacolata Concezione (8 Dicembre)
			{ month: 11, day: 25 },// Natale (25 Dicembre)
			{ month: 11, day: 26 } // Santo Stefano (26 Dicembre)
		];

		// Trova la Pasqua e il Lunedì dell'Angelo (Pasquetta)
		const easterSunday = getEasterSunday(year);
		const pasquetta = new Date(easterSunday);
		pasquetta.setDate(pasquetta.getDate() + 1);

		// Aggiungi Pasqua e Pasquetta all'array delle festività
		holidays.push(
			{ month: easterSunday.getMonth(), day: easterSunday.getDate() },
			{ month: pasquetta.getMonth(), day: pasquetta.getDate() }
		);

		let result = [];

		// Itera su tutti i giorni dell'anno
		for (let month = 0; month < 12; month++) {
			for (let day = 1; day <= new Date(year, month + 1, 0).getDate(); day++) {
				let date = new Date(year, month, day);
				let dayOfWeek = date.getDay();

				// Se è sabato (6) o domenica (0), aggiungi all'array
				if (dayOfWeek === 0 || dayOfWeek === 6) {
					result.push(new Date(year, month, day));
				}

				// Se è una festività, aggiungila all'array
				if (holidays.some(h => h.month === month && h.day === day)) {
					result.push(new Date(year, month, day));
				}
			}
		}

		return result;
	}

// Funzione per calcolare la data della Pasqua per un dato anno
	function getEasterSunday(year) {
		let a = year % 19;
		let b = Math.floor(year / 100);
		let c = year % 100;
		let d = Math.floor(b / 4);
		let e = b % 4;
		let f = Math.floor((b + 8) / 25);
		let g = Math.floor((b - f + 1) / 3);
		let h = (19 * a + b - d - g + 15) % 30;
		let i = Math.floor(c / 4);
		let k = c % 4;
		let l = (32 + 2 * e + 2 * i - h - k) % 7;
		let m = Math.floor((a + 11 * h + 22 * l) / 451);
		let month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
		let day = ((h + l - 7 * m + 114) % 31) + 1;
		return new Date(year, month, day);
	}

	if ($('input.date').length > 0) {
		$( 'input.date' ).pickadate({
			monthsFull: [ 'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre' ],
			monthsShort: [ 'Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic' ],
			weekdaysShort: [ 'Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab' ],
			today: 'Oggi',
			clear: '',
			close: 'Chiudi',
			labelMonthNext: 'Mese successivo',
			labelMonthPrev: 'Mese precedente',
			labelMonthSelect: 'Scegli mese',
			labelYearSelect: 'Scegli anno',
			formatSubmit: 'dd/mm/yyyy',
			selectYears: 2,
			firstDay: 1,
			min: 1,
			disable: getHolidaysAndWeekends()
		})
	}
});


// WEBPACK FOOTER //
// ./scripts/elements/_pickadate.js